import React, { memo } from 'react';
import { Section } from './Section';
export function PainPoints() {
  const points = [{
    emoji: '😮‍💨',
    text: 'Entrás a una habitación y no recordás a qué fuiste, o se te olvida el nombre de algo que usás todos los días.'
  }, {
    emoji: '🔍',
    text: 'Buscás ejercicios para entrenar la memoria y lo que encontrás son cosas para chicos o actividades que te aburren en dos minutos.'
  }, {
    emoji: '🔄',
    text: 'Sentís que tu mente ya no es tan rápida como antes, y te preocupa que con los años pueda empeorar.'
  }, {
    emoji: '😤',
    text: 'A veces tus hijos o familiares te preguntan si estás bien cuando te olvidás algo, y eso te incomoda y te pesa.'
  }, {
    emoji: '🧠',
    text: 'Querés hacer algo serio por tu cabeza, pero no querés ir a talleres, ni gastar una fortuna, ni pelearte con aplicaciones complicadas.'
  }];
  return <Section className="bg-white" data-id="element-127">
      <div className="text-center mb-12" data-id="element-128">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-129">
          ¿Te pasa alguna de estas cosas?
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-130">
          Si tenés más de 50 años, seguro te reconocés en una o más de estas
          situaciones.
        </p>
      </div>

      <div className="space-y-4 max-w-3xl mx-auto mb-12" data-id="element-131">
        {points.map((point, index) => <div key={index} className="flex gap-4 p-5 rounded-xl bg-cream-dark border border-gray-100 items-start" data-id="element-132">
            <span className="text-3xl shrink-0 leading-none" data-id="element-133">
              {point.emoji}
            </span>
            <p className="text-gray-800 leading-relaxed" data-id="element-134">{point.text}</p>
          </div>)}
      </div>
    </Section>;
}